import { Check, Exclamation } from "react-bootstrap-icons";
import { BounceLoader } from "react-spinners";

const SuccessIcon = ({ className }) => {
  return (
    <div className={"size-[80px] rounded-full bg-primary-100 flex items-center justify-center " + className}>
      <Check size={56} className="text-primary" />
    </div>
  );
};

const FailIcon = ({ className }) => {
  return (
    <div className={"size-[80px] rounded-full bg-red-100 flex items-center justify-center " + className}>
      <Exclamation size={56} className="text-red-500" />
    </div>
  );
};

const ProcessingIcon = ({ className }) => {
  return (
    <div className={"size-[80px] rounded-full bg-primary-100 flex items-center justify-center " + className}>
      <BounceLoader size={56} color="#F95816" />
    </div>
  );
};

export {
  SuccessIcon, FailIcon, ProcessingIcon
}